import CtaBanner from "../components/CtaBanner";
import AppScreenshots from "../components/AppScreenshots";

const TIMELINE = [
  { n: "01", title: "Register your restaurant",   desc: "Create your account and add your outlet name, GST details, and address. Takes under 2 minutes." },
  { n: "02", title: "Set up your menu",           desc: "Add categories, menu items, prices, and your table layout — fully customisable from the admin panel." },
  { n: "03", title: "Staff start taking orders",  desc: "Any staff member can take orders on an Android device immediately. No training required." },
  { n: "04", title: "Kitchen gets instant KOT",   desc: "The kitchen receives the order ticket the moment it's placed. No paper slips, no calls." },
  { n: "05", title: "Bill & collect payment",     desc: "Generate a GST-compliant invoice and accept cash, card, or UPI — all in one tap." },
];

const VALUES = [
  { icon: "☁️", title: "Cloud Synced",      desc: "Data accessible on every device, always backed up." },
  { icon: "🇮🇳", title: "GST Compliant",    desc: "All GST types handled automatically." },
  { icon: "📱", title: "Any Android Device", desc: "No expensive hardware. Works on what you already have." },
  { icon: "⚡", title: "Zero Setup",         desc: "No Windows, no IT. Start billing in minutes." },
];

const STATS = [
  ["11+", "Years Experience"],
  ["500+", "Restaurants Served"],
  ["20+", "Features"],
  ["2", "Countries"],
];

export default function AboutPage({ nav }) {
  return (
    <div className="page">

      {/* ── HERO ── */}
      <div className="about-top">
        <div style={{ maxWidth: 560 }}>
          <div className="eyebrow">About Ooon</div>
          <h1 style={{ fontSize: "clamp(2rem,4vw,3rem)", fontWeight: 900, lineHeight: 1.08, marginBottom: 14, fontFamily: "'Fraunces',serif" }}>
            All-in-one restaurant<br />management, <em style={{ color: "var(--g2)" }}>simplified</em>
          </h1>
          <p style={{ color: "var(--muted)", fontSize: "1rem", lineHeight: 1.8, maxWidth: 480 }}>
            Ooon is a cloud-based restaurant management system from <strong style={{ color: "var(--ink)" }}>Buyp</strong>.
            Built for Indian food businesses — from single outlets to franchise chains.
          </p>
        </div>
      </div>

      {/* ── STORY + TIMELINE ── */}
      <section className="section">
        <div className="ag">

          {/* Left: story */}
          <div>
            <div className="eyebrow">Our Approach</div>
            <h2 className="sec-title" style={{ fontSize: "1.9rem" }}>
              Why restaurant owners<br /><em>choose Ooon</em>
            </h2>
            <p style={{ color: "var(--muted)", lineHeight: 1.8, marginBottom: 16, fontSize: "0.96rem" }}>
              Most POS systems are either too expensive or too complicated for small and mid-size
              restaurants. Ooon was built to fix that — a fully-featured cloud POS that works on
              any Android device, needs zero configuration, and gets your team billing in minutes.
            </p>
            <p style={{ color: "var(--muted)", lineHeight: 1.8, marginBottom: 36, fontSize: "0.96rem" }}>
              With over 11 years in the software industry, the team behind Ooon has built it
              around real problems Indian restaurant owners face — GST compliance, kitchen
              communication, and staff management.
            </p>
            <div className="val-grid">
              {VALUES.map((v, i) => (
                <div className="vc" key={i}>
                  <div className="vc-icon">{v.icon}</div>
                  <h4>{v.title}</h4>
                  <p>{v.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Right: step-by-step */}
          <div className="about-box">
            <div style={{ fontSize: "0.68rem", fontWeight: 700, textTransform: "uppercase", letterSpacing: 1.5, color: "var(--muted)", marginBottom: 20 }}>
              From Setup to First Bill
            </div>
            <div>
              {TIMELINE.map((t, i) => (
                <div className="tl-item" key={i}>
                  <div className="tl-dot">{t.n}</div>
                  <div className="tl-c">
                    <h4>{t.title}</h4>
                    <p>{t.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </section>

      {/* ── APP SCREENSHOTS ── */}
      <AppScreenshots />

      {/* ── STATS ── */}
      <div className="stats-bar">
        {STATS.map(([n, l], i) => (
          <div key={i}>
            <div className="sb-n">{n}</div>
            <div className="sb-l">{l}</div>
          </div>
        ))}
      </div>

      <div style={{ height: 80 }} />
      <CtaBanner
        title="Join hundreds of restaurants using Ooon"
        subtitle="Free for 15 days. No credit card required."
        btnText="Try Ooon Free →"
      />
    </div>
  );
}
